import {ServiceClass} from '@/decorators';
import {ROLES, ROLE_TYPES} from '@/globals';
import {RoleModel, UserSession} from '@/sdk';
import {PlanApiService, TranslationsApi, UsersApi} from '@/sdk/api-services';
import {PaymentApiService} from '@/sdk/api-services/payment.api';
import {RoleApi} from '@/sdk/api-services/role.api';

@ServiceClass()
export class RolesService {
    public rolesApi: RoleApi = new RoleApi();

    public UserSession: UserSession = new UserSession();

    public translationApi: TranslationsApi = new TranslationsApi();
    public planApi: PlanApiService = new PlanApiService();

    private roles: Array<RoleModel> = [];

    public accountRoles: Array<RoleModel> = [];
    public siteRoles: Array<RoleModel> = [];
    public teamRoles: Array<RoleModel> = [];
    public jobRoles: Array<RoleModel> = [];

    public constructor() {
        this.getRoles();
        this.UserSession._session.subscribe(s => {
            if (s?.userId) {
                this.getUserRolePermissions(s.userId);
                this.getPaymentStatus();
                if (s.accountId) {
                    this.getPlanPermissions(s.accountId);
                }
            }
        });
    }

    public getRoles() {
        this.rolesApi
            .getAll()
            .then((res: any) => {
                this.roles = res ?? [];
                // console.log('ROLES:');
                // console.log(this.roles);
                this.roles.sort((roleA, roleB) => ((roleA.name ?? '') > (roleB.name ?? '') ? 1 : -1));

                this.accountRoles = this.roles.filter(r => r.type === ROLE_TYPES.ACCOUNT);
                this.siteRoles = this.roles.filter(r => r.type === ROLE_TYPES.SITE);
                this.teamRoles = this.roles.filter(r => r.type === ROLE_TYPES.TEAM);
                this.jobRoles = this.roles.filter(r => r.type === ROLE_TYPES.JOB);

                this.accountRoles = this.accountRoles.filter(r => {
                    if (r.slug === ROLES.SYS_ADMIN) {
                        if (this.UserSession.isSystemAdmin) {
                            return true;
                        }
                        return false;
                    }
                    return true;
                });

                // if (this.UserSession.Session?.roleId) {
                //     new RolesService().getRolePermissions(this.UserSession.Session.roleId);
                // }
            })
            .catch(err => {
                //
            });
    }

    public getRolePermissions(roleId: string) {
        new RoleApi().getRolePermissions(roleId).subscribe(
            res => {
                this.UserSession.rolePermissions$.next(res.Data?.map(x => x.permission!) ?? []);
            },
            err => {
                //
            }
        );
    }

    public getUserRolePermissions(userId: string) {
        new UsersApi()
            .userRolePermissionKeys(userId)
            .then(res => {
                this.UserSession.rolePermissions$.next(res ?? []);
                this.UserSession.permissionsLoaded$.next(true);
            })
            .catch(err => {
                //
            });
    }

    public getPaymentStatus() {
        new PaymentApiService()
            .getCurrentUserPaymentStatus()
            .then(res => {
                this.UserSession.paymentStatus$.next(res);
                this.UserSession.paymentStatusLoaded$.next(true);
            })
            .catch(err => {
                //
            });
    }

    public getPlanPermissions(accountId: string) {
        this.planApi
            .getPlanPermissions(accountId)
            .then(res => {
                this.UserSession.planPermissions$.next(res?.permissions ?? []);
                this.UserSession.planPermissionsLoaded$.next(true);
            })
            .catch(err => {
                this.UserSession.planPermissions$.next([]);
                this.UserSession.planPermissionsLoaded$.next(true);
            });
    }
}
